import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DollarSign, FileText, Target, TrendingUp, Timer } from 'lucide-react';
import SalesReports from './SalesReports';
import ClearviewReports from './ClearviewReports';
import KPIDashboard from './KPIDashboard';
import WeeklyAnalysis from './WeeklyAnalysis';
import ServiceTimes from './ServiceTimes';

const TABS = [
  { id: 'overview', label: 'Sales Overview', icon: DollarSign, Comp: SalesReports },
  { id: 'kpis', label: 'KPI Dashboard', icon: Target, Comp: KPIDashboard },
  { id: 'weekly', label: 'Weekly Analysis', icon: TrendingUp, Comp: WeeklyAnalysis },
  { id: 'service', label: 'Service Times', icon: Timer, Comp: ServiceTimes },
  { id: 'reports', label: 'Clearview Reports', icon: FileText, Comp: ClearviewReports },
];

export default function SalesKPIs() {
  const [params, setParams] = useSearchParams();
  const initial = TABS.find(t => t.id === params.get('tab'))?.id || 'overview';
  const [tab, setTab] = useState(initial);
  const Active = TABS.find(t => t.id === tab)?.Comp || SalesReports;

  const select = (id) => { setTab(id); setParams(id === 'overview' ? {} : { tab: id }, { replace: true }); };

  return (
    <div className="space-y-4" data-testid="sales-kpis-page">
      <div>
        <p className="text-[11px] uppercase tracking-[0.25em] text-[#F26522] font-semibold">Performance · Clearview</p>
        <h1 className="text-2xl sm:text-3xl font-black text-[#3E2418] tracking-tight" style={{ fontFamily: 'Chivo, sans-serif' }}>Sales &amp; KPIs</h1>
      </div>
      <div className="flex gap-1.5 overflow-x-auto pb-1 -mx-1 px-1 sticky top-0 z-10" data-testid="sales-kpis-tabs">
        {TABS.map(t => {
          const Icon = t.icon;
          const active = t.id === tab;
          return (
            <button
              key={t.id}
              onClick={() => select(t.id)}
              data-testid={`sales-tab-${t.id}`}
              className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-semibold transition-colors ${active ? 'bg-[#F26522] text-white' : 'bg-white text-slate-600 border border-[#E5E1DA] hover:bg-[#FAF8F5]'}`}
            >
              <Icon className="w-4 h-4" />{t.label}
            </button>
          );
        })}
      </div>
      <div data-testid="sales-kpis-panel">
        <Active />
      </div>
    </div>
  );
}
